import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useAnimation } from 'framer-motion6';
import { BENEFITS, SIZES } from '../../consts';

import { BenefitContainer, Title, Description, ScaleWrapper } from './styled';

const BenefitDescription = ({ benefits, selectedBenefit }) => {
  const benefit = benefits.find((b) => b.id === selectedBenefit);
  const descriptionControls = useAnimation();

  useEffect(() => {
    const { size } = BENEFITS[selectedBenefit];
    const height = SIZES[size];

    descriptionControls.start({
      height,
      transition: { duration: 0.01 }
    });
  }, [selectedBenefit]);

  return (
    <ScaleWrapper>
      <BenefitContainer animate={descriptionControls}>
        <Title>
          {benefit?.icon}
          <h3>{benefit?.name}</h3>
        </Title>
        <Description>{benefit?.description}</Description>
      </BenefitContainer>
    </ScaleWrapper>
  );
};

BenefitDescription.propTypes = {
  benefits: PropTypes.array.isRequired,
  selectedBenefit: PropTypes.number.isRequired
};

export default BenefitDescription;
